// extracted by mini-css-extract-plugin
export var formContainer = "styles-module__formContainer___uufPI";